import { createStore } from 'vuex'
import { readStorage, writeStorage } from '@/utils/storage'
import { filterKeys } from '@/assets/filters'

const STORAGE_KEY = "isContentWarningAccepted";

// Derive the shape from the config so a new filter cannot be forgotten here
const emptyFilters = Object.fromEntries(filterKeys.map((key) => [key, null]));

export default createStore({
  state: {
    isContentWarningAccepted:
      readStorage(STORAGE_KEY) === "true",
    // One entry per filter in assets/filters.js, keyed the same way. null means
    // "everything" for that filter, be it all years, all artists or every tag of
    // a facet. Kept in memory on purpose: filters are reset on navigation, so
    // there is nothing worth persisting.
    filters: { ...emptyFilters },
  },
  getters: {
  },
  mutations: {
    setContentWarningAccepted(state, accepted) {
      state.isContentWarningAccepted = accepted;
      writeStorage(STORAGE_KEY, accepted);
    },
    setFilter(state, { key, value }) {
      state.filters[key] = value;
    },
    resetFilters(state) {
      for (const key of Object.keys(state.filters)) {
        state.filters[key] = null;
      }
    },
  },
  actions: {
  },
  modules: {
  }
})
